import type { Fragrance } from './types.js';

// Chanel pages and pairs carry no buying links.
export function isChanelFragrance(fragrance: Fragrance): boolean {
  return fragrance.brand?.slug === 'chanel';
}
